export default __webpack_public_path__ + "static/media/logo-crio-dark.d1634a02.png";